var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsWohlbefindenNiedrigFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-1 0 32 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-wohlbefinden-niedrig-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-wohlbefinden-niedrig-filled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,30 C23.2852174,30 30,23.2852174 30,15 C30,6.71478261 23.2852174,0 15,0 C6.71478261,0 0,6.71478261 0,15 C0,23.2852174 6.71478261,30 15,30 Z",
    id: "Stroke-5",
    stroke: "#7F8BDB",
    fill: "#7F8BDB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 10,
    x2: 11,
    y2: 10,
    id: "Stroke-1",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 10,
    x2: 18,
    y2: 10,
    id: "Stroke-2",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,21.6017379 L19.7747909,18.3997104 C19.6629382,18.1535119 19.4352853,18 19.1852618,18 C18.9365542,18 18.7089012,18.1535119 18.5970486,18.3997104 C18.5970486,18.3997104 15.4875458,22 15.2375223,22 C14.9888147,22 14.7611618,21.8464881 14.6493091,21.6017379 L11.879312,18.3997104 C11.7674593,18.1535119 11.5398064,18 11.2897829,18 C11.0410753,18 10.8134223,18.1535119 10.7015697,18.3997104 L8,21.4496741",
    id: "Stroke-3",
    stroke: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWohlbefindenNiedrigFilled);
export default __webpack_public_path__ + "static/media/icons-wohlbefinden-niedrig-filled.7a174a29ea88768d7667b9b45818172d.svg";
export { ForwardRef as ReactComponent };